import { useMemo } from 'react';
import { MenuNavigationShellPage } from '@/app/layout/MenuNavigationShellPage';
import type { AgendaRegistration } from '@/app/layout/MenuNavigationShellPage';
import { SECURITY_ROLE_PERMISSIONS } from './permissions';
import { rolePermissionsAgenda } from './role-permissions/rolePermissionsAgenda';
import { RolePermissionsPage } from './role-permissions/RolePermissionsPage';

export function SecuritySlicePage() {
  const agendas: AgendaRegistration[] = useMemo(
    () => [
      {
        agenda: rolePermissionsAgenda,
        component: RolePermissionsPage,
        permission: SECURITY_ROLE_PERMISSIONS,
      },
    ],
    []
  );

  return <MenuNavigationShellPage agendas={agendas} rootAgenda={rolePermissionsAgenda} />;
}
